import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { func, string } from 'prop-types';
import React from "react";

var IntersectionObserverWrapper = /*#__PURE__*/function () {
  function IntersectionObserverWrapper(callback) {
    _classCallCheck(this, IntersectionObserverWrapper);

    this.observedItems = [];
    this.callback = callback;
  }

  _createClass(IntersectionObserverWrapper, [{
    key: "start",
    value: function start(margin) {
      var _this = this;

      this.observer = new global.IntersectionObserver(function (entries) {
        return _this.onObservation(entries);
      }, {
        rootMargin: margin,
        threshold: 0
      });
      this.observedItems.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            dom = _ref2[0],
            component = _ref2[1];

        return _this.observer.observe(dom);
      });
    }
  }, {
    key: "onObservation",
    value: function onObservation(entries) {
      var _this2 = this;

      entries.filter(function (entry) {
        return entry.isIntersecting === undefined || entry.isIntersecting;
      }).map(function (entry) {
        return entry.target;
      }).forEach(function (dom) {
        var index = _this2.observedItems.findIndex(function (x) {
          return x[0] === dom;
        });

        if (index > -1) {
          var component = _this2.observedItems[index][1];

          _this2.callback(component);

          _this2.unregister(dom, component);
        }
      });
    }
  }, {
    key: "register",
    value: function register(dom, component) {
      this.observedItems.push([dom, component]);
      this.observer && this.observer.observe(dom);
    }
  }, {
    key: "unregister",
    value: function unregister(dom, component) {
      var index = this.observedItems.findIndex(function (x) {
        return x[0] === dom;
      });

      if (index > -1) {
        this.observedItems.splice(index, 1);
        this.observer && this.observer.unobserve(dom);
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.observer.disconnect();
    }
  }]);

  return IntersectionObserverWrapper;
}();

var StubObserverWrapper = /*#__PURE__*/function () {
  function StubObserverWrapper(callback) {
    _classCallCheck(this, StubObserverWrapper);

    this.callback = callback;
  }

  _createClass(StubObserverWrapper, [{
    key: "register",
    value: function register(dom, component) {
      this.callback(component);
    }
  }, {
    key: "start",
    value: function start() {}
  }, {
    key: "unregister",
    value: function unregister() {}
  }, {
    key: "disconnect",
    value: function disconnect() {}
  }]);

  return StubObserverWrapper;
}();
/**
 * This component will ensure all {@link ResponsiveImages} that are in its descendent path will be loaded async. By default, the image is loaded with an empty gif, and the image becomes visible when the image scrolls 250 from the edge of the screen.
 *
 * You can use {@link EagerLoadImages} or `eager={true}` to force the image to be eager. If `EagerLoadImages` is passed a predicate, then images that pass a matching value to `eager` will be rendered eagerly.
 *
 * Example
 * ```javascript
 * import { LazyLoadImages, EagerLoadImages } from '@quintype/components';
 *
 * function LazyLoadSecondImage() {
 *   return <div>
 *     <ResponsiveImage slug={props["eager-image-1"]} />
 *     <LazyLoadImages margin={"450px"}>
 *       <div>
 *         <UnrelatedContent/>
 *         <ResponsiveImage slug={props["lazy-image-1"]} />
 *         <ResponsiveImage slug={props["lazy-image-forced-to-be-eager"]} eager/>
 *         <ResponsiveImage slug={props["lazy-image-2"]} />
 *         <EagerLoadImages>
 *           <ResponsiveImage slug={props["lazy-image-forced-to-be-eager"]} />
 *         </EagerLoadImages>
 *         <EagerLoadImages predicate={(token) => token % 2 === 0}>
 *           <ResponsiveImage slug={props["lazy-image"]} eager={1} />
 *           <ResponsiveImage slug={props["eager-image"]} eager={2} />
 *         </EagerLoadImages>
 *       </div>
 *     </LazyLoadImages>
 *     <ResponsiveImage slug={props["eager-image-2"]} />
 *   </div>
 * }
 * ```
 * @component
 * @category Images
 */


export var LazyLoadImages = /*#__PURE__*/function (_React$Component) {
  _inherits(LazyLoadImages, _React$Component);

  var _super = /*#__PURE__*/_createSuper(LazyLoadImages);

  function LazyLoadImages(props) {
    var _this3;

    _classCallCheck(this, LazyLoadImages);

    _this3 = _super.call(this, props);

    var callback = function callback(component) {
      return component.showImage();
    };

    _this3.observerWrapper = global.IntersectionObserver ? new IntersectionObserverWrapper(callback) : new StubObserverWrapper(callback);
    return _this3;
  }

  _createClass(LazyLoadImages, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.observerWrapper.start(this.props.margin || "500px");
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.observerWrapper.disconnect();
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      var _this4 = this;

      return {
        lazyLoadObserveImage: function lazyLoadObserveImage(dom, component) {
          return dom && _this4.observerWrapper.register(dom, component);
        },
        lazyLoadUnobserveImage: function lazyLoadUnobserveImage(dom, component) {
          return dom && _this4.observerWrapper.unregister(dom, component);
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return LazyLoadImages;
}(React.Component);
LazyLoadImages.childContextTypes = {
  lazyLoadObserveImage: func,
  lazyLoadUnobserveImage: func
};